<template>
  <el-row>
    <el-form ref="StationAuthInfoDetailRef"
             v-form
             :model="StationAuthInfoDetailForm"
             :rules="rules"
             addAction=""
             editAction=""
             label-width="150px"
             selectAction="/gasStation/getGasStationDetail.action"
             style="width:50%"
             @onSelectInfo="onSelectInfo">

      <el-divider content-position="left"><strong>基础信息</strong></el-divider>
      <el-form-item label="公众号授权链接" prop="publicWeChatUrl">
        <el-input v-model="StationAuthInfoDetailForm.publicWeChatUrl" :disabled="true" placeholder="授权链接"></el-input>
      </el-form-item>
      <el-form-item label="加油站名称" prop="name">
        <el-input v-model="StationAuthInfoDetailForm.name" :disabled="true" placeholder="加油站名称"></el-input>
      </el-form-item>
      <el-form-item label="加油站地址" prop="detailAddress">
        <el-input v-model="StationAuthInfoDetailForm.detailAddress" :disabled="true" placeholder="加油站地址"></el-input>
      </el-form-item>
      <el-form-item label="封面照" prop="image">
        <el-upload v-model="StationAuthInfoDetailForm.img" :data="{floder:'gasStation'}" :disabled="true" :http-request="onHttpRequest"
                   :show-file-list="false" accept="image/*" action="upload/uploadPic"
                   class="avatar-uploader">
          <el-image  fit="fill" v-if="StationAuthInfoDetailForm.img" :preview-src-list="new Array(StationAuthInfoDetailForm.img.url)"
                     :src="StationAuthInfoDetailForm.img.url" class="avatar"> </el-image>
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          <div slot="tip" class="el-upload__tip"><p>建议尺寸：750*460px <span style="color:red;">最多1张</span></p></div>
        </el-upload>
      </el-form-item>
      <el-form-item label="营业执照照片" prop="businessLicense">
        <el-upload v-model="StationAuthInfoDetailForm.businessLicense" :data="{floder:'gasStation'}" :disabled="true" :http-request="onHttpRequest"
                   :show-file-list="false" accept="image/*" action="upload/uploadPic"
                   class="avatar-uploader">
          <el-image  fit="fill" v-if="StationAuthInfoDetailForm.businessLicense" :preview-src-list="new Array(StationAuthInfoDetailForm.businessLicense.url)"
                     :src="StationAuthInfoDetailForm.businessLicense.url" class="avatar"> </el-image>
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          <div slot="tip" class="el-upload__tip"><p>建议尺寸：750*460px <span style="color:red;">最多1张</span></p></div>
        </el-upload>
      </el-form-item>
      <el-form-item label="特殊资质" prop="qualificationsImg">
        <el-upload v-model="StationAuthInfoDetailForm.qualificationsImg" :data="{floder:'gasStation'}" :disabled="true" :http-request="onHttpRequest"
                   :show-file-list="false" accept="image/*"
                   action="upload/uploadPic" class="avatar-uploader">
          <el-image  fit="fill" v-if="StationAuthInfoDetailForm.qualificationsImg" :preview-src-list="new Array(StationAuthInfoDetailForm.qualificationsImg.url)"
                     :src="StationAuthInfoDetailForm.qualificationsImg.url" class="avatar"> </el-image>
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          <div slot="tip" class="el-upload__tip"><p>建议尺寸：750*460px <span style="color:red;">最多1张</span></p></div>
        </el-upload>
      </el-form-item>

      <el-divider content-position="left"><strong>法人信息</strong></el-divider>
      <el-form-item label="法人身份证正面" prop="legalFrontCard">
        <el-upload v-model="StationAuthInfoDetailForm.legalFrontCard" :data="{floder:'gasStation'}" :disabled="true" :http-request="onHttpRequest"
                   :show-file-list="false" accept="image/*" action="upload/uploadPic"
                   class="avatar-uploader">
          <el-image  fit="fill" v-if="StationAuthInfoDetailForm.legalFrontCard" :preview-src-list="new Array(StationAuthInfoDetailForm.legalFrontCard.url)"
                     :src="StationAuthInfoDetailForm.legalFrontCard.url" class="avatar"> </el-image>
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          <div slot="tip" class="el-upload__tip"><p>建议尺寸：750*460px <span style="color:red;">最多1张</span></p></div>
        </el-upload>
      </el-form-item>
      <el-form-item label="法人身份证反面" prop="legalReverseCard">
        <el-upload v-model="StationAuthInfoDetailForm.legalReverseCard" :data="{floder:'gasStation'}" :disabled="true" :http-request="onHttpRequest"
                   :show-file-list="false" accept="image/*" action="upload/uploadPic"
                   class="avatar-uploader">
          <el-image  fit="fill" v-if="StationAuthInfoDetailForm.legalReverseCard" :preview-src-list="new Array(StationAuthInfoDetailForm.legalReverseCard.url)"
                     :src="StationAuthInfoDetailForm.legalReverseCard.url" class="avatar"> </el-image>
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          <div slot="tip" class="el-upload__tip"><p>建议尺寸：750*460px <span style="color:red;">最多1张</span></p></div>
        </el-upload>
      </el-form-item>

      <el-divider content-position="left"><strong>经营者信息</strong></el-divider>
      <el-form-item label="经营者姓名" prop="gasStationLeaderName">
        <el-input v-model="StationAuthInfoDetailForm.gasStationLeaderName" :disabled="true" placeholder="经营者姓名"></el-input>
      </el-form-item>
      <el-form-item label="经营者手机" prop="gasStationLeaderPhone">
        <el-input v-model="StationAuthInfoDetailForm.gasStationLeaderPhone" :disabled="true" placeholder="经营者手机"></el-input>
      </el-form-item>
      <el-form-item label="邮箱账号" prop="email">
        <el-input v-model="StationAuthInfoDetailForm.email" :disabled="true" placeholder="邮箱账号"></el-input>
      </el-form-item>
      <el-form-item label="经营者身份证正面" prop="frontCard">
        <el-upload v-model="StationAuthInfoDetailForm.frontCard" :data="{floder:'gasStation'}" :disabled="true" :http-request="onHttpRequest"
                   :show-file-list="false" accept="image/*" action="upload/uploadPic"
                   class="avatar-uploader">
          <el-image  fit="fill" v-if="StationAuthInfoDetailForm.frontCard" :preview-src-list="new Array(StationAuthInfoDetailForm.frontCard.url)"
                     :src="StationAuthInfoDetailForm.frontCard.url" class="avatar"> </el-image>
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          <div slot="tip" class="el-upload__tip"><p>建议尺寸：750*460px <span style="color:red;">最多1张</span></p></div>
        </el-upload>
      </el-form-item>
      <el-form-item label="经营者身份证反面" prop="reverseCard">
        <el-upload v-model="StationAuthInfoDetailForm.reverseCard" :data="{floder:'gasStation'}" :disabled="true" :http-request="onHttpRequest"
                   :show-file-list="false" accept="image/*" action="upload/uploadPic"
                   class="avatar-uploader">
          <el-image  fit="fill" v-if="StationAuthInfoDetailForm.reverseCard" :preview-src-list="new Array(StationAuthInfoDetailForm.reverseCard.url)"
                  :src="StationAuthInfoDetailForm.reverseCard.url" class="avatar"> </el-image>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            <div slot="tip" class="el-upload__tip"><p>建议尺寸：750*460px <span style="color:red;">最多1张</span></p></div>
        </el-upload>
      </el-form-item>
      <el-divider content-position="left"><strong>结算账户</strong></el-divider>
      <el-form-item label="开户名称" prop="accountName">
        <el-input v-model="StationAuthInfoDetailForm.accountName" :disabled="true" placeholder="开户名称"></el-input>
      </el-form-item>
      <el-form-item label="开户行" prop="bankName">
        <el-input v-model="StationAuthInfoDetailForm.bankName" :disabled="true" placeholder="开户行"></el-input>
      </el-form-item>
      <el-form-item label="开户支行" prop="accountOpeningBranch">
        <el-input v-model="StationAuthInfoDetailForm.accountOpeningBranch" :disabled="true" placeholder="开户支行"></el-input>
      </el-form-item>
      <el-form-item label="银行账号" prop="bankCardNumber">
        <el-input v-model="StationAuthInfoDetailForm.bankCardNumber" :disabled="true" placeholder="银行账号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="$router.back()">返回</el-button>
      </el-form-item>
    </el-form>
  </el-row>
</template>

<script>
import BasicPager from '@/mixins/BasicPager'

export default {
  name: 'StationAuthInfoDetail',
  extends: BasicPager,
  components: {},
  data: function () {
    return {
      rules: {},
      srcList: [
        'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg',
        'https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg'
      ],
      StationAuthInfoDetailForm: {
        id: null
      }
    }
  },
  created () {
    this.StationAuthInfoDetailForm.id = this.$route.query.id
  },
  methods: {
    onFilterParams: function (params) {},
    onSelectInfo: function (dataInfo) {}
  },
  filters: {}

}
</script>

<style scoped>

</style>
